<template>
  <div  class="hello">
   <img class="logo" src="../assets/logo_w.jpg">
    <div class="welcome">
      <h1 class="big_header cssa7d0b7c7315c17">{{ msg }}</h1>
      <h4>{{ chi_msg }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      msg: "Welcome To JialeDai's Blog",
      chi_msg:"2017新版博客系统【枫言枫语】已发布"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  color: #333;
  text-align: center;
  font-family:'Helvetica-Neue-8f6b45bba15c17','PingFang SC', 'Helvetica Neue', 'Helvetica', 'STHeitiSC-Light', 'Arial', sans-serif;
  margin-bottom: 30px;
}
.big_header{
  font-size: 50px;
  margin-bottom: 30px;
}
.logo{
  max-width: 430px;
  max-height: 430px;
}
.welcome{
  background-color: #fff;
  margin: 30px;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?4cadadfc